import { cn } from '@zealot/ui/lib/utils';
import type * as React from 'react';

type FieldErrorProps = React.ComponentProps<'p'>;

function FieldError({ className, children, ...props }: FieldErrorProps) {
  if (!children) return null;

  return (
    <p
      data-slot="field-error"
      role="alert"
      className={cn('font-medium text-destructive text-xs', className)}
      {...props}
    >
      {children}
    </p>
  );
}

export { FieldError };
